<template>
  <div class="qna-button-show">
    <Buttonv2
      block
      size="lg"
      @click="showqna()"
      v-if="useButtonV2"
      variant="outline-dark"
    >
      <span>{{ $t("askQuestionButton") }}</span>
      <i class="far fa-sm fa-question-circle pl-1" />
    </Buttonv2>

    <ui-button
      block
      v-else
      size="lg"
      @click="showqna()"
      :variant="slide.type === 'question' ? 'primary' : 'outline-dark'"
    >
      <span>{{ $t("askQuestionButton") }}</span>
      <i class="far fa-sm fa-question-circle" />
    </ui-button>
  </div>
</template>

<script>
import { mapState } from 'vuex'

// utils
import utils from '@/util'

// UI
import UiButton from '@/components/UI/Button'
import Buttonv2 from '@/components/UI/Buttonv2.vue'

export default {
  components: {
    Buttonv2,
    UiButton,
  },
  props: {
    useButtonV2: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      slide: (state) => state.slide,
    }),
  },
  methods: {
    showqna() {
      this.$store.state.showQaSession = true
      utils.gaTrackEvent('Audience', 'Ask a question > Click')
    },
  },
}
</script>
